/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Stores } from '../../models/stores';

export interface TenantsTenantIdStoresGet$Params {
  tenantId: string;
}

export function tenantsTenantIdStoresGet(http: HttpClient, rootUrl: string, params: TenantsTenantIdStoresGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Stores>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdStoresGet.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Stores>;
    })
  );
}

tenantsTenantIdStoresGet.PATH = '/tenants/{tenantId}/stores';
